import { SET_PAYMENT_DETAILS } from './constants'

export const setPaymentDetails = payload => (
  {
    type: SET_PAYMENT_DETAILS,
    payload,
  }
)



// WEBPACK FOOTER //
// ./src/containers/Cart/Payment/actions.js